var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5607 16.4397L14.7529 12.6319C15.5397 11.4461 16.0002 10.0263 16.0002 8.50008C16.0002 4.36454 12.6356 1 8.50008 1C4.36454 1 1 4.36454 1 8.50008C1 12.6356 4.36454 16.0002 8.50008 16.0002C10.0263 16.0002 11.4461 15.5397 12.6319 14.7529L16.4397 18.5607C17.0247 19.1464 17.9757 19.1464 18.5607 18.5607C19.1464 17.9749 19.1464 17.0254 18.5607 16.4397ZM3.25002 8.50008C3.25002 5.60505 5.60505 3.25002 8.50008 3.25002C11.3951 3.25002 13.7501 5.60505 13.7501 8.50008C13.7501 11.3951 11.3951 13.7501 8.50008 13.7501C5.60505 13.7501 3.25002 11.3951 3.25002 8.50008Z",
    fill: "white",
    stroke: "#4C1E8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.24bdb1769975dc609a2218e1e3a2e8b4.svg";
export { ForwardRef as ReactComponent };